import React, { useState } from "react";

import { Button, Col, FormLabel, Row } from "react-bootstrap";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";

import { AppContext } from "../AppContext.js";
import { BaseBean } from "../ds/client_ds.js";
import { ExitIcon, PlayIcon } from "../gui_components/Icons.js";
import { PopupFabricStyleModule } from "../modules/ModuleUtil.js";

import { ConfigManager } from "../config/ConfigManager.js";
import {
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  InventoryLocationTransferBean,
  InventoryLocationTransferLineBean,
  MassInventoryLocationTransferBean,
  PageListBean,
  PurchaseOrderSearchCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestPurchaseOrderListRequest,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  SKUBatchInventorySearchCriteria,
  SKUInventoryBean,
} from "../ds/ds.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import CustomTable from "../gui_components/CustomTable.js";
import { ModuleUtils } from "./ModuleUtils.js";
class MassInventoryTransfer extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Mass Inventory Transfer Maintenance",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: true,
      isShowExcelButton: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,

      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new SKUBatchInventorySearchCriteria(),
      inventoryBean: new SKUInventoryBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,

      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      moduleForPopup: [],
      inquiryData: null,
      colorLookupHandler: null,
      isShowColorLookup: false,
      isShowTransferPopup: false,
      isActive: false,
      selectedDataList: [],
      locations: [],
      isLoading: false,
      isDisabledFields: false,
      isShowLookup: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: true,
      isShowAutoCompletePurchaseOrderList: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      showAutoCompleteLocationPopupList: false,
      locationPopupPageListForAutoCompleteList: new Array(),
      is3PL: false,
    };
  }
  componentDidMount() {
    //
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    const locations = new Array();
    if (!isEmptyArray(attribute_cache.warehouses))
      locations.push(...attribute_cache.warehouses);
    this.state.locations = ModuleUtils.isActiveAttribute(locations);

    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    let purchaseLookupHandler = new PurchaseOrderLookupHandler(
      this.companyCode,
      "Purchase Order"
    );
    this.setState({ purchaseLookupHandler: purchaseLookupHandler });

    let locationLookupHandler = new GenericAttributeLookupHandler(
      this.state.locations,
      "Location"
    );
    this.setState({ locationLookupHandler: locationLookupHandler });
  };
  componentDidUpdate() {
    //
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisabledFields: true,
    });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        fabricColorPageListForAutoCompleteList: suggestion,
        showAutoCompleteFabricColorList: false,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };

  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readFabricStyle(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  readFabricStyleResponse = (response) => {
    let fabricStyle = response.data.fabricStyle;
    if (fabricStyle != null) {
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = fabricStyle.code;
      criteria.fabricStyleName = fabricStyle.description;

      this.setState({ criteria: criteria, isShowColorLookup: true });
      this.fabricStyleSelected(fabricStyle);
    }
  };
  readFabricStyleError = (error) => {};

  readFabricStyle = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    if (SecurityAccessManager.MassInventoryTransfer_IsAccessible()) {
      FabricStyleService.readFabricStyle(
        input,
        this.readFabricStyleResponse,
        this.readFabricStyleError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  fabricStyleSelected = (fabricStyle) => {
    let colors = fabricStyle.colors;
    let finalColorList = [];
    colors.map((ent) => {
      let colorBean = new BaseBean();
      colorBean.code = ent.fabricStyleColorCode;
      colorBean.description = ent.fabricStyleColorName;
      finalColorList.push(colorBean);
    });
    this.setState({ colorLookupHandler: null });
    if (finalColorList != null) {
      let colorLookupHandler = new GenericAttributeLookupHandler(
        finalColorList,
        "Color"
      );
      this.setState({
        colorLookupHandler: colorLookupHandler,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        isShowColorLookup: true,
        colorList: finalColorList,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();

    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  onLocationChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.criteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        criteria: criteria,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.locations.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };
  readLocationBySearchString(searchString) {
    let locationData = this.state.locations;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((locations) => {
        let simpleItemBean = {
          code: locations.code,
          description: locations.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ locationPageListForAutoCompleteList: filteredSuggestions });
  }
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteLocationList) => {
    this.setState({
      showAutoCompleteLocationList: showAutoCompleteLocationList,
    });
  };
  onPurchaseOrderChange = (e) => {
    let purchaseOrderNumber = e.target.value;
    this.state.isShowAutoCompletePurchaseOrderList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
    if (isEmpty(purchaseOrderNumber)) {
      this.state.isShowAutoCompletePurchaseOrderList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
      let criteria = this.state.criteria;
      criteria.purchaseOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        purchaseOrderPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderNumber !== ""
    ) {
      this.readPurchaseOrderBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  readPurchaseOrderBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readPurchaseOrderBySearchStringResponse,
      this.errorCallBack
    );
  }
  readPurchaseOrderBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (response.data.purchaseOrderPageList != null) {
      if (purchaseorderData.length > 0 && purchaseorderData != null) {
        purchaseorderData.map((po) => {
          let simpleItemBean = {
            code: po.code,
            description: "",
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
    }
    this.setState({
      purchaseOrderPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  purchaseOrderEnterKeyEventHandler = (e) => {
    let poCode = e.target.value;
    this.readPurchaseOrder(poCode);
    this.setState({
      purchaseOrderPageListForAutoCompleteList: new Array(),
    });
  };
  readPurchaseOrder = (purchaseOrderCode) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading PurchaseOrder ..",
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseOrderCode;
    PurchaseOrderService.readPurchaseOrder(
      readrestInput,
      this.readPurchaseOrderResponse,
      this.errorCallBack
    );
  };
  readPurchaseOrderResponse = (response) => {
    if (response.data != null && response.data != null) {
      if (!isEmptyArray(response.data.purchaseOrder)) {
        let poBean = response.data.purchaseOrder;
        let criteria = this.state.criteria;
        criteria.purchaseOrderNumber = poBean.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompletePurchaseOrderList: showAutoCompleteList,
    });
  };

  loadPage = (pageNumber) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ..",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;

    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPageNumber = 1;

    let listRequest = new RestSkuBatchInventoryListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;

    if (!isEmptyString(criteria.fabricStyleCode)) {
      this.loadMassInventoryTransferList(listRequest);
    } else {
      let errMsg = "";
      if (!this.state.is3PL) {
        errMsg = "Fabric Style is required!";
      } else {
        errMsg = "Item is required!";
      }
      let errList = this.state.error_list;
      errList.push(errMsg);
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadMassInventoryTransferList = (criteria) => {
    if (SecurityAccessManager.MassInventoryTransfer_IsAccessible()) {
      InventoryService.getSkuBatchInventoryPageList(
        criteria,
        this.loadMassInventoryTransferPageResponse,
        this.loadMassInventoryTransferPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadMassInventoryTransferPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      let resultList = new Array();
      if (
        !isEmpty(response.data.skuBatchInventoryPageList) &&
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories
        )
      ) {
        resultList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
        let dataList = resultList.filter((inv) => inv.onHandQuantity > 0);
        this.setState({
          inquiryDataList: dataList,
        });
      } else {
        this.setState({
          inquiryDataList: resultList,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  // loadMassInventoryTransferPageResponse = (response) => {
  //   this.setState({
  //     isLoading: false,
  //     loadingText: "",
  //   });
  //   let inquiryDataList =
  //     response.data.skuBatchInventoryPageList.skuBatchInventories;
  //   let dataList = inquiryDataList.filter((inv) => inv.onHandQuantity > 0);
  //   if (inquiryDataList != null) {
  //     this.setState({
  //       isInquiryDatasFound: true,
  //       isShowResetButton: true,
  //       inquiryDataList: dataList,
  //     });
  //   } else {
  //     let errMsg = "No data Found";
  //     let errList = this.state.error_list;
  //     errList.push(errMsg);

  //     this.setState({ error_list: errList });
  //     this.setState({
  //       alertMessage: errList,
  //       alertType: "danger",
  //       isShowAlert: true,
  //     });
  //     this.setState({
  //       isInquiryDatasFound: false,
  //       inquiryDataList: [],
  //     });
  //   }
  // };
  loadMassInventoryTransferPageError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };

  execute = () => {
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new SKUBatchInventorySearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.fabricStyleName = "";
    this.setState({
      criteria: tempCriteria,
      isShowColorLookup: false,
      colorList: new Array(),
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let tempCriteria = new SKUBatchInventorySearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.colorCode = "";
    tempCriteria.fabricStyleName = "";
    let inventoryBean = this.state.inventoryBean;
    inventoryBean.locationCode = "";
    this.setState({
      inventoryBean: inventoryBean,
      criteria: tempCriteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowColorLookup: false,
      colorList: new Array(),
      isShowLookup: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isDisabledFields: false,
      selectedDataList: new Array(),
    });
    this.hideAlertCallBack();
  };
  invOnChange = (e) => {
    let inventoryBean = this.state.inventoryBean;

    inventoryBean[e.target.name] = e.target.value;

    this.setState({ inventoryBean: inventoryBean });
  };

  transferLine = () => {
    if (!isEmptyArray(this.state.selectedDataList)) {
      this.setState({ isShowTransferPopup: true });
    } else {
      let errMsg = "Select the Line";
      let error_list = [];
      error_list.push(errMsg);
      this.setState({
        alertMessage: error_list,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  createTransfer = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Creating Transfer ..",
      });
      let selectedDataList = this.state.selectedDataList;
      let inventoryBean = this.state.inventoryBean;
      let toLocationCode = inventoryBean.locationCode;
      let locationCodes = [];
      /*selectedDataList.map(list =>{
    	locationCodes.push(list.locationCode);    
     })*/
      let location = selectedDataList
        .filter(
          (loc, ind) =>
            ind ===
            selectedDataList.findIndex(
              (lc) => lc.locationCode === loc.locationCode
            )
        )
        .map((list) => {
          locationCodes.push(list.locationCode);
        });
      let inventoryTransferBean = null;
      let transferLine = null;
      let transfer_list = [];
      for (let code of locationCodes) {
        inventoryTransferBean = this.toInventoryTransferBean(
          code,
          toLocationCode
        );
        transfer_list.push(inventoryTransferBean);
      }
      if (inventoryTransferBean != null) {
        let massTransfer = new MassInventoryLocationTransferBean();
        massTransfer.count = 0;
        massTransfer.transferList = transfer_list;
        if (massTransfer != null)
          this.createMassInventoryTransfer(massTransfer);
      }
    }
  };

  toInventoryTransferBean = (fromLocationCode, toLocationCode) => {
    let inquiryData = this.state.inquiryData;
    let selectedDataList = this.state.selectedDataList;
    let transferBean = new InventoryLocationTransferBean();
    transferBean.companyCode = this.companyCode;
    transferBean.code = "NEW";
    transferBean.transferReason = "MASS TRANSFER";
    transferBean.status = "O";
    //transferBean.documentType = "DOC1";
    //transferBean.documentNumber = "12345";

    transferBean.remarks = "CREATED IN MASS LOCATION TRANSFER ";
    transferBean.fromLocationCode = fromLocationCode;
    transferBean.toLocationCode = toLocationCode;
    let lnBeanList = [];
    if (selectedDataList != null) {
      let lineNumber = 1;
      for (let lnData of selectedDataList) {
        if (lnData.locationCode == fromLocationCode) {
          //selectedDataList.map((lnData,index)=>{
          //if(lnData.onHandQuantity == qty ){
          let lnBean = new InventoryLocationTransferLineBean();
          lnBean.companyCode = transferBean.companyCode;
          lnBean.transferCode = transferBean.code;
          lnBean.lineNumber = lineNumber;
          lnBean.fabricStyleCode = lnData.fabricStyleCode;
          lnBean.fabricStyleShortName = lnData.fabricStyleName;
          lnBean.fabricStyleColorCode = lnData.fabricStyleColorCode;
          lnBean.skuNumber = lnData.skuNumber;
          lnBean.uomCode = lnData.uomCode;
          lnBean.transferQuantity = lnData.onHandQuantity;

          lnBean.fromLocationCode = fromLocationCode;
          lnBean.vendorBatchNumber = lnData.vendorBatchNumber;
          lnBean.toLocationCode = toLocationCode;
          lnBean.widthCode = lnData.widthCode;
          lnBean.rollNumber = lnData.rollNumber;
          lnBean.rollSkuNumber = lnData.rollSkuNumber;

          lnBean.aisleInfoText = lnData.aisleInfoText;
          lnBean.containerNumber = lnData.containerNumber;
          lnBean.reserveCustomerCode = lnData.reserveCustomerCode;
          lnBean.reserveCustomerName = lnData.reserveCustomerName;
          lnBean.originalPurchaseOrderNumber = lnData.purchaseOrderNumber;
          lnBean.originalPurchaseReceiptNumber =
            lnData.purchaseOrderReceiptNumber;
          lnBean.originalReceivedQuantity = lnData.receivedQuantity;
          lnBean.vendorSkuNumber = lnData.vendorSkuNumber;
          lnBean.fobCost = lnData.fobCost;
          lnBean.landedCost = lnData.landedCost;
          lnBean.boxNumber = "$$$";
          lnBeanList.push(lnBean);
          ++lineNumber;
        }
      }
      // })
      transferBean.transferLines = lnBeanList;
    }

    return transferBean;
  };
  createMassInventoryTransfer = (trBean) => {
    this.setState({ isShowTransferPopup: false });
    if (SecurityAccessManager.MassInventoryTransferCreate_IsAccessible()) {
      InventoryService.createMassInventoryLocationTransfer(
        trBean,
        this.createMassInventoryTransferPageResponse,
        this.createMassInventoryTransferPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  createMassInventoryTransferPageResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    /*let criteria = this.state.criteria;
	let pageInput = new RestPageListBean();
	pageInput.pageSize = 50;
	pageInput.currentPageNumber = 1;
	
	let listRequest = new RestSkuBatchInventoryListRequest();
	listRequest.searchCriteria = criteria;
	listRequest.pageInput = pageInput;
	  
	this.loadMassInventoryTransferList(listRequest);*/
  };
  createMassInventoryTransferPageError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("error :", error);
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  viewFabricModule = (e, code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowFabricStyleModule: true,
        moduleForPopup: (
          <PopupFabricStyleModule
            fabricStyleCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };

  closeModalCallBack = (isOpen) => {
    this.setState({ isShowFabricStyleModule: isOpen, moduleForPopup: [] });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowTransferPopup: isShowPopup,
      isShowAlert: isShowPopup,
      selectedDataList: new Array(),
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  checkLine = (e, rowData) => {
    let selectedDataList = this.state.selectedDataList;
    rowData.isActive = e.target.value;
    let selectedData = null;
    if (rowData.isActive === true) {
      selectedData = { ...rowData };
      selectedDataList.push(rowData);
      this.setState({
        selectedDataList: selectedDataList,
        inquiryData: selectedData,
      });
    } else {
      let selectedDataList = this.state.selectedDataList;
      let invList = [];
      for (let item of selectedDataList) {
        if (item.isActive != rowData.isActive) {
          selectedData = item;
          invList.push(item);
          // this.setState({ selectedDataList: invList });
        }
        // else if (selectedDataList.length == 1) {
        //   this.setState({ selectedDataList: [] });
        // }
      }
      this.setState({ selectedDataList: invList, inquiryData: selectedData });
    }
  };
  checkLine__ = (e, rowData) => {
    /*let selectedLine = [];
	  let inquiryDataList = this.state.inquiryDataList;
	  selectedLine.push(rowData);	 	
	  this.setState({selectedDataList : selectedLine,		  
		             inquiryData  :rowData,		            
		             });
	  */
    let selectedLine = [];
    let selectedData = null;
    let inquiryDataList = this.state.inquiryDataList;
    rowData.isActive = e.target.value;
    inquiryDataList.map((line, i) => {
      // if (line.isActive == true) {
      if (line.isActive == rowData.isActive) {
        if (line.isActive == true) {
          selectedData = line;
          selectedLine.push(selectedData);
        }
      }
    });
    // inquiryDataList.filter(sp =>sp.isActive === rowData.isActive).map((line,i)=>{
    //  selectedLine.push(line);
    //})

    this.setState({
      selectedDataList: selectedLine,
      inquiryData: selectedData,
    });
  };
  inventoryTransferColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", false)
        .setInputDetails(false, false, true, null, this.checkLine, null)
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SKU", "skuNumber", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Container", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("P.O", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Receipt", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("BinLoc", "aisleInfoText", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorBatch", "vendorBatchNumber", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll", "rollNumber", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorSKU", "vendorBatchNumber", true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    );

    return columns;
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isActive",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null
        )
        .setEditableDetails(false, "", null, false, null, true, this.checkLine)
    );
    if (this.state.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "Item",
          "fabricStyleCode",
          0,
          true,
          this.viewFabricModule
        )
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "FabricStyle",
          "fabricStyleCode",
          0,
          true,
          this.viewFabricModule
        )
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails("Name#", "fabricStyleName")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("color", "fabricStyleColorCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Width", "widthCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber",
        1
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("SKU#", "skuNumber", 1)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Container", "containerNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("P.O#", "purchaseOrderNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Receipt#",
        "purchaseOrderReceiptNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("BinLoc", "aisleInfoText")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Location", "locationCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "VendorBatch",
        "vendorBatchNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Roll", "rollNumber")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "VendorSKU",
        "vendorBatchNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Customer", "customerCode")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("CustomerName", "customerName")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "OnHandQty",
        "onHandQuantity",
        1
      )
    );

    return columnList;
  };
  closeTransfer = (e) => {
    if (e.detail == 1) {
      let inventoryBean = this.state.inventoryBean;
      inventoryBean.locationCode = "";
      this.setState({
        isShowTransferPopup: false,
        inventoryBean: inventoryBean,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  onLocationPopupChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationPopupList = true;
    let inventoryBean = this.state.inventoryBean;
    let showAutoCompleteList = this.state.showAutoCompleteLocationPopupList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationPopupList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationPopupList;
      let inventoryBean = this.state.inventoryBean;
      inventoryBean.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationPopupList: showAutoCompleteList,
        inventoryBean: inventoryBean,
        locationPopupPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationPopupBySearchString(locationCode);
    }
    inventoryBean[e.target.name] = e.target.value;
    this.setState({ inventoryBean: inventoryBean });
  };

  locationPopupEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocationCode(locationCode);
    this.setState({
      locationPopupPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationPopupList = (
    showAutoCompleteLocationPopupList
  ) => {
    this.setState({
      showAutoCompleteLocationPopupList: showAutoCompleteLocationPopupList,
    });
  };

  readLocationCode = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.locations.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_inventoryBean = this.state.inventoryBean;
      temp_inventoryBean.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationPopupList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationPopupList;
      this.setState({
        inventoryBean: temp_inventoryBean,
        showAutoCompleteLocationPopupList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };

  readLocationPopupBySearchString(searchString) {
    let locationData = this.state.locations;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((locations) => {
        let simpleItemBean = {
          code: locations.code,
          description: locations.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      locationPopupPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let criteria = this.state.criteria;
    let isLoading = this.state.isLoading;
    let inquiryData = this.state.inquiryData;
    let inventoryBean = this.state.inventoryBean;
    // let isLoading = this.props.isLoading;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        <BaseInquiryToolBar
          isShowExitButton={this.state.isShowExitButton}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          onModuleExit={this.moduleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
        />

        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          fabricLookupHandler={this.state.fabricLookupHandler}
          resetInquiry={this.resetInquiry}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          onLocationChange={this.onLocationChange}
          locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
          displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
          onPurchaseOrderChange={this.onPurchaseOrderChange}
          purchaseOrderEnterKeyEventHandler={
            this.purchaseOrderEnterKeyEventHandler
          }
          displayAutoCompletePurchaseOrderList={
            this.displayAutoCompletePurchaseOrderList
          }
          transferLine={this.transferLine}
        />
        {/* {isLoading ? <Loader loadingText="isssss" /> : null} */}
        {this.state.isInquiryDatasFound && (
          <div className="div_Custom_4">
            {/* <EditableDataGrid
              columnsList={this.columnDefinitions()}
              dataList={inquiryDataList}
            /> */}
            <CustomTable
              columns={this.inventoryTransferColumns()}
              data={inquiryDataList}
              label={"Inventory Transfer List"}
            />
          </div>
        )}
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel6"}
          isModulePopup={false}
          isShowPopup={this.state.isShowTransferPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={
            this.state.is3PL
              ? "Item Location Transfer"
              : "Fabric Location Transfer"
          }
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.createTransfer(e)}
              >
                Update
              </Button>

              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.closeTransfer(e)}
              >
                <ExitIcon /> Exit{" "}
              </Button>
            </div>
          }
          content={
            <div className="sales_line_pop">
              <Row className="">
                <FormLabel> Transfer Details </FormLabel>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Location</FormLabel>
                </Col>
                <Col sm="2">
                  {/* <InputTextbox
                    name="locationCode"
                    value={inventoryBean.locationCode}
                    onChange={this.invOnChange}
                    lookupRequired={true}
                    lookupHandler={this.state.locationLookupHandler}
                  />{" "} */}
                  <InputTextbox
                    name="locationCode"
                    value={inventoryBean.locationCode}
                    lookupRequired={true}
                    lookupHandler={this.state.locationLookupHandler}
                    onChange={this.onLocationPopupChange}
                    enterKeyEventHandler={
                      this.locationPopupEnterKeyEventHandler
                    }
                    autoCompleteListData={
                      this.state.locationPopupPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteLocationPopupList
                    }
                    showAutoCompleteList={
                      this.state.showAutoCompleteLocationPopupList
                    }
                  />{" "}
                </Col>
              </Row>
            </div>
          }
        />

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);

  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const resetInquiry = () => {
    handleButton();
    props.resetInquiry();
  };
  const transferLine = (e) => {
    if (e.detail == 1) {
      handleButton();
      props.transferLine();
    }
  };
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };

  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const locationEnterKeyEventHandler = (e) => {
    props.locationEnterKeyEventHandler(e);
  };
  const displayAutoCompleteLocationList = () => {
    props.displayAutoCompleteLocationList();
  };

  const onLocationChange = (e) => {
    props.onLocationChange(e);
  };
  const purchaseOrderEnterKeyEventHandler = (e) => {
    props.purchaseOrderEnterKeyEventHandler(e);
  };
  const displayAutoCompletePurchaseOrderList = () => {
    props.displayAutoCompletePurchaseOrderList();
  };

  const onPurchaseOrderChange = (e) => {
    props.onPurchaseOrderChange(e);
  };
  let criteria = props.criteria;
  let isShowColorLookup = props.isShowColorLookup;
  let fabricLookupHandler = props.fabricLookupHandler;
  let fabricCodeRef = React.createRef();

  let colorLookupHandler = props.colorLookupHandler;
  let colorCodeRef = React.createRef();

  let purchaseLookupHandler = props.purchaseLookupHandler;
  let purchaseCodeRef = React.createRef();

  let locationLookupHandler = props.locationLookupHandler;
  let locationCodeRef = React.createRef();

  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricSTyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={colorCodeRef}
            name="colorCode"
            onChange={onFabricColourCodeChange}
            value={criteria.colorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>

        <Col sm="1">
          {" "}
          <FormLabel>RollNumber</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="rollNumber"
            onChange={onChange}
            value={criteria.rollNumber}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          {" "}
          <FormLabel>Location</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="locationCode"
            value={criteria.locationCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.locationLookupHandler}
            onChange={onLocationChange}
            ref={locationCodeRef}
            enterKeyEventHandler={locationEnterKeyEventHandler}
            autoCompleteListData={props.locationPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteLocationList}
            showAutoCompleteList={props.showAutoCompleteLocationList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>

        <Col sm="1">
          {" "}
          <FormLabel>PO#</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={purchaseCodeRef}
            onChange={onPurchaseOrderChange}
            disabled={props.isDisabledFields}
            name="purchaseOrderNumber"
            placeholder="purchaseOrderNumber"
            value={criteria.purchaseOrderNumber}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.purchaseLookupHandler}
            enterKeyEventHandler={purchaseOrderEnterKeyEventHandler}
            autoCompleteListData={
              props.purchaseOrderPageListForAutoCompleteList
            }
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompletePurchaseOrderList}
            showAutoCompleteList={props.isShowAutoCompletePurchaseOrderList}
            isMandatory={true}
          />
        </Col>

        <Col sm="1">
          {" "}
          <FormLabel>Container#</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="containerNumber"
            onChange={onChange}
            value={criteria.containerNumber}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          {" "}
          <FormLabel>{props.is3PL ? "Inventory#" : "RollSKU#"}</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="rollSkuNumber"
            onChange={onChange}
            value={criteria.rollSkuNumber}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>

        <Col sm="1">
          {" "}
          <FormLabel>Sku#</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="skuNumber"
            onChange={onChange}
            value={criteria.skuNumber}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
        {props.isInquiryDatasFound && (
          <Col sm="2">
            <Button
              id="fabric_Add_Button"
              size="sm"
              onClick={(e) => transferLine(e)}
            >
              <PlayIcon />
              {""}Transfer
            </Button>
          </Col>
        )}
      </Row>
    </div>
  );
}
function MassInventoryTransferModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <MassInventoryTransfer {...props} name="" /> <br />
    </div>
  );
}

export default MassInventoryTransferModule;
